// Ordnet Länder-Namen (englisch, so wie die Odds-API sie liefert) einem Flaggen-Emoji zu.
// Emoji-Flaggen bestehen aus zwei "regional indicator"-Zeichen -> keine Bild-Assets nötig.
const LAND_ZU_CODE = {
  'Austria': 'AT', 'Germany': 'DE', 'England': 'GB', 'Spain': 'ES', 'Italy': 'IT',
  'France': 'FR', 'Netherlands': 'NL', 'Portugal': 'PT', 'Belgium': 'BE', 'Switzerland': 'CH',
  'Scotland': 'GB', 'Turkey': 'TR', 'Greece': 'GR', 'Poland': 'PL', 'Czech-Republic': 'CZ',
  'Czech Republic': 'CZ', 'Slovakia': 'SK', 'Slovenia': 'SI', 'Croatia': 'HR', 'Serbia': 'RS',
  'Hungary': 'HU', 'Romania': 'RO', 'Bulgaria': 'BG', 'Ukraine': 'UA', 'Russia': 'RU',
  'Sweden': 'SE', 'Norway': 'NO', 'Denmark': 'DK', 'Finland': 'FI', 'Iceland': 'IS',
  'Ireland': 'IE', 'Wales': 'GB', 'Northern-Ireland': 'GB', 'Bosnia': 'BA', 'Albania': 'AL',
  'North-Macedonia': 'MK', 'Montenegro': 'ME', 'Kosovo': 'XK', 'Armenia': 'AM', 'Azerbaijan': 'AZ',
  'Georgia': 'GE', 'Israel': 'IL', 'Cyprus': 'CY', 'Malta': 'MT', 'Luxembourg': 'LU',
  'Andorra': 'AD', 'San-Marino': 'SM', 'Gibraltar': 'GI', 'Faroe-Islands': 'FO', 'Estonia': 'EE',
  'Latvia': 'LV', 'Lithuania': 'LT', 'Moldova': 'MD', 'Belarus': 'BY', 'Kazakhstan': 'KZ',
  'USA': 'US', 'Brazil': 'BR', 'Argentina': 'AR', 'Mexico': 'MX', 'Japan': 'JP',
  'South-Korea': 'KR', 'China': 'CN', 'Australia': 'AU', 'Saudi-Arabia': 'SA', 'Qatar': 'QA',
  'Morocco': 'MA', 'Egypt': 'EG', 'Nigeria': 'NG', 'Ghana': 'GH', 'Senegal': 'SN',
  'Tunisia': 'TN', 'Algeria': 'DZ', 'South-Africa': 'ZA', 'Canada': 'CA'
}

function codeZuFlagge(code) {
  return String.fromCodePoint(...[...code.toUpperCase()].map(c => 127397 + c.charCodeAt(0)))
}

export function ligaFlagge(land) {
  if (!land || land === 'World') return null
  const code = LAND_ZU_CODE[land]
  return code ? codeZuFlagge(code) : null
}